import { render, staticRenderFns } from "./EnvironmentBanner.vue?vue&type=template&id=251c54fb&"
import script from "./EnvironmentBanner.vue?vue&type=script&lang=js&"
export * from "./EnvironmentBanner.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports